import { FC } from 'react';

import { SPACING } from '~/common/layout-propertis/spacing';
import { Typography } from '~/common/components/Typography';
import { Modal } from '~/common/components/Modal';

import { StyContainer, StyContent } from '../styles';

interface IPoliticasModal {
  open: boolean;
  close: () => void;
}

export const PoliticasModal: FC<IPoliticasModal> = ({ open, close }) => {
  return (
    <Modal
      id="politica-privacidade-modal"
      isOpen={open}
      onClose={close}
      height="600px"
      width="700px"
      justifyContent="start"
      title="Política de Privacidade"
      closeOnOutsideClick
    >
      <StyContainer>
        <StyContent>
          <Typography.Label size="medium">Introdução</Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Seja bem-vindo ao CryptoControl. Esta Política de Privacidade
            descreve como coletamos, usamos, protegemos e compartilhamos suas
            informações pessoais. Estamos comprometidos em garantir a
            privacidade e a segurança dos seus dados.
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">
            Coleta de Informações
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Coletamos informações pessoais que você nos fornece diretamente ao
            se registrar em nosso sistema, tais como:
          </Typography.Label>
          <Typography.Label size="small" color="neutral.200">
            -Nome e Sobrenome
          </Typography.Label>
          <Typography.Label size="small" color="neutral.200">
            -Endereço de e-mail
          </Typography.Label>
          <Typography.Label size="small" color="neutral.200">
            -Informações de pagamento
          </Typography.Label>
          <Typography.Label
            size="small"
            color="neutral.400"
            style={{ marginTop: `${SPACING._16}` }}
          >
            Também coletamos automaticamente informações técnicas, como:
          </Typography.Label>
          <Typography.Label size="small" color="neutral.200">
            -Tipo de navegador
          </Typography.Label>
          <Typography.Label size="small" color="neutral.200">
            -Páginas visitadas dentro do nosso sistema
          </Typography.Label>
          <Typography.Label size="small" color="neutral.200">
            -Tempo gasto no site
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">Uso das Informações</Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Utilizamos suas informações para:
          </Typography.Label>
          <Typography.Label size="small" color="neutral.200">
            -Fornecer, operar e manter nosso sistema
          </Typography.Label>
          <Typography.Label size="small" color="neutral.200">
            -Processar transações e enviar notificações
          </Typography.Label>
          <Typography.Label size="small" color="neutral.200">
            -Melhorar nosso serviço e personalizar sua experiência
          </Typography.Label>
          <Typography.Label size="small" color="neutral.200">
            -Enviar comunicações promocionais e atualizações
          </Typography.Label>
          <Typography.Label size="small" color="neutral.200">
            -Cumprir obrigações legais e resolver disputas
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">
            Proteção de Informações
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Adotamos medidas de segurança para proteger suas informações
            pessoais, incluindo:
          </Typography.Label>
          <Typography.Label size="small" color="neutral.200">
            -Criptografia de dados
          </Typography.Label>
          <Typography.Label size="small" color="neutral.200">
            -Controle de acesso restrito
          </Typography.Label>
          <Typography.Label size="small" color="neutral.200">
            -Monitoramento contínuo de segurança
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">
            Compartilhamento de Informações
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Nós não vendemos, trocamos ou alugamos suas informações pessoais .
            Podemos compartilhar suas informações com:
          </Typography.Label>
          <Typography.Label size="small" color="neutral.200">
            Provedores de serviços terceirizados para operar nosso sistema. Por
            exemplo, processadores de pagamento.
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">Seus Direitos</Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Você tem o direito de:
          </Typography.Label>
          <Typography.Label size="small" color="neutral.200">
            -Acessar e atualizar suas informações pessoais
          </Typography.Label>
          <Typography.Label size="small" color="neutral.200">
            -Solicitar a exclusão de seus dados pessoais
          </Typography.Label>
          <Typography.Label size="small" color="neutral.200">
            -Optar por não receber comunicações promocionais
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">
            Cookies e Tecnologias de Rastreamento
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Utilizamos cookies e outras tecnologias de rastreamento para
            melhorar sua experiência no site, analisar o tráfego e entender de
            onde vêm nossos visitantes.
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">
            Alterações na Política de Privacidade
          </Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Podemos atualizar esta Política de Privacidade periodicamente.
            Notificaremos você sobre quaisquer mudanças publicando a nova
            política em nosso site e atualizando a data de revisão.
          </Typography.Label>
        </StyContent>
        <StyContent>
          <Typography.Label size="medium">Contato</Typography.Label>
          <Typography.Label size="small" color="neutral.400">
            Se você tiver dúvidas sobre esta Política de Privacidade, entre em
            contato conosco através do e-mail
            <Typography.Label
              size="small"
              color="green.500"
              style={{ paddingLeft: `${SPACING._4}` }}
            >
              contact@cryptocontrol.pro
            </Typography.Label>
          </Typography.Label>
        </StyContent>
      </StyContainer>
    </Modal>
  );
};
